import * as React from "react";

import "./paper-type.scss";

import {IsShowPricing}          from "@Common/logic/check-show-pricing";
import {cs}                     from "@Common/react/chain-services";
import {scn} from "@Common/react/state-change-nested-value";
import {Select}                 from "@Common/ui-components/heavy/common/design2/select/select";

import {MoneySpan} from "../../../../../../common/form/money-span/money-span";

import {Coating} from "./coating/coating";

export const PaperType = ({state, paperTypes, paperType, finishing, finishingTypes, totalQuantity}) => cs(
    ["showPricing", (_, next) => IsShowPricing({next})],
    ({showPricing}) => (
        <div className="paper-type-1i9" xd-qa-type="card" xd-qa-name="Paper Type">
            <div className="header">
                <div className="title" xd-qa-type="label" xd-qa-name="Paper Type Label">
                    Paper Type
                </div>
            </div>

            <div className="card">
                {paperTypes.length === 1 ? (
                    <div className="value" xd-qa-type="label" xd-qa-name="Paper Type">
                        {paperType.name}
                    </div>
                ) : (
                    <div className="select">
                        {Select({
                            list: paperTypes,
                            itemToLabel: (o) => o?.name,
                            itemToInfo: (o) => !showPricing ? null : MoneySpan({value: o?.unitPrice ? +o.unitPrice: 0}),
                            onChange: (o) => scn(state, ["paperTypeId"], () => o.id),
                            isSelected: (o) => o.id === paperType?.id,
                            xdQaName: "Paper Type",
                        })}
                    </div>
                )}
                
                {Coating({
                        finishingTypes,
                        selected: finishing,
                        totalQuantity,
                        onSelect: (finishing) => scn(state, ["finishing"], () => finishing),
                })}
            </div>
        </div>
    ),
);
